import { apiClient } from '../config/api';

// FEAT-042 — admin Not a Fit Audit page support service (MVP-8.8).
// Wraps GET /admin/not-a-fit so the admin-web UI doesn't talk to the
// REST API directly.

export interface AdminNotAFitRecord {
  id: string;
  markerId: string;
  targetId: string;
  createdAt: string;
  undoneAt: string | null;
}

export interface AdminNotAFitListResponse {
  items: AdminNotAFitRecord[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface AdminNotAFitListFilters {
  markerId?: string;
  targetId?: string;
  includeUndone?: boolean;
  page?: number;
  limit?: number;
}

class NotAFitAuditService {
  async list(filters: AdminNotAFitListFilters = {}): Promise<AdminNotAFitListResponse> {
    const params = new URLSearchParams();
    if (filters.markerId) params.set('markerId', filters.markerId);
    if (filters.targetId) params.set('targetId', filters.targetId);
    if (filters.includeUndone) params.set('includeUndone', 'true');
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));

    const qs = params.toString();
    const response = await apiClient.get<{
      success: boolean;
      data: AdminNotAFitRecord[];
      pagination: AdminNotAFitListResponse['pagination'];
      timestamp: string;
    }>(`/admin/not-a-fit${qs ? `?${qs}` : ''}`);

    return {
      items: response.data.data,
      pagination: response.data.pagination,
    };
  }
}

export const notAFitAuditService = new NotAFitAuditService();
